import { SectionItem } from '@features/shift-post-v2/components'
import { connect } from 'formik'
import {
  calculateShiftAmount,
  calculateShiftTotal,
  calculateUpshiftFee,
} from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { Box, Flex, Text } from '@pinchenterprisesnpm/friday-ui'
import { IEstimatedTotalSectionProps } from './estimated-total-section.types'

export const EstimatedTotalSection = connect<IEstimatedTotalSectionProps>(({ formik }) => {
  const {
    values: {
      hour_start: startTime,
      hour_end: endTime,
      pay_value: rate,
      break: unpaidBreak,
      commission_percent: commissionPercent,
    },
  } = formik

  const totalShiftAmount = calculateShiftAmount({
    startTime,
    endTime,
    rate,
    unpaidBreak,
  })
  const upshiftFee = calculateUpshiftFee({
    commissionPercent,
    totalShiftAmount,
  })
  const shiftTotal = calculateShiftTotal({
    totalShiftAmount,
    upshiftFee,
  })

  return (
    <SectionItem title='Estimated Total' hasEdit={false}>
      <Box
        mx='xs'
        mt='xs'
        mb='xs'
        p='ls'
        style={{
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
        }}
      >
        <Flex px='sm' justify='space-between' alignItems='center' mb='xs'>
          <Text fontSize='medium' fontWeight='normal'>
            Shift Amount:
          </Text>

          <Text fontSize='medium' fontWeight='semiBold'>
            ${totalShiftAmount.toFixed(2)}
          </Text>
        </Flex>

        <Flex px='sm' justify='space-between' alignItems='center' mb='xs'>
          <Text fontSize='medium' fontWeight='normal'>
            Upshift Fee ({commissionPercent * 100}%):
          </Text>

          <Text fontSize='medium' fontWeight='semiBold'>
            ${upshiftFee.toFixed(2)}
          </Text>
        </Flex>

        <Box
          pt='xs'
          mt='xs'
          style={{
            borderTop: '1px solid #e5e7eb',
          }}
        >
          <Flex px='sm' justify='space-between' alignItems='center'>
            <Text fontSize='large' fontWeight='semiBold'>
              Total to Charge:
            </Text>

            <Text fontSize='large' fontWeight='bold'>
              ${shiftTotal.toFixed(2)}
            </Text>
          </Flex>
        </Box>
      </Box>
    </SectionItem>
  )
})
